import React from 'react'
import { BlogHeader } from '../BlogHeader'
import { BlogContent } from '../BlogContent'

export const BlogContainer = ({ blog }) => {
  return (
    <React.Fragment>
      <BlogHeader {...blog} />
      <BlogContent {...blog} />
    </React.Fragment>
  )
}
